module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAYAAADJViUEAAAAs0lEQVQ4T+2SsQ4BQRCGv7ladTuFivfwDki0Kp3E80h0KjoND+E5aCjmrtHfyspdwnGLTmG7yf7fPzN/Rog859why7Juk0RisKp6M2vU/OFael8HpqpHYGZmuwpW1T4wN7POvf9T2qVwBYyBLTAAbnUwfIBfjVYarIEWcHkFBk6a9goG3vuliEzqHUP3KBy7vN+AT0VRjPI8378btfpP07SXJMlGnHNDEVkA7U9h4Oy9n14BuIVm42hMXhMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dataDowload_04.png
// module id = dNBB
// module chunks = 1